import {
  DialogPositioningBehavior,
  DialogProps,
  DialogType,
  DialogWidget
} from '@tableau/widgets';
import React from 'react';

  import { Messages } from '~src/codegen/Localize';
import { CloseAndDismiss, ReactModalService } from '~src/commonInfra/dialogs/ReactModalService';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';

import { KMSKeyGenerateView } from '../components/KMSKeyGenerateView';
import { IGetSiteEncryptionKeyDataKey } from '../models/CredentialEncryptionModels';


export const openGenerateKMSKeyDialog = (dataKeyIds: IGetSiteEncryptionKeyDataKey[], coolDownPeriod: number): void => {
      ReactModalService.openCustom(closeAndDismiss => {
          const dialogProps = ReactModalService.getDefaultDialogProps({
              type: DialogType.NormalWithTitleBar,
              title: Messages.credentialEncryptionTOLKeyGenerateKeyPrompt(),
              testId: 'generate-data-key-dialog',
              showCloseButton: true,
              dialogWidth: TabDialogWidth.width600px,
              positioningBehavior: DialogPositioningBehavior.Draggable,
              shouldNotCloseOnGlassClick: true
          }, closeAndDismiss);
          return getDialogWidget(dialogProps, closeAndDismiss, dataKeyIds, coolDownPeriod);
      });

  };


  function getDialogWidget(dialogProps: DialogProps, closeAndDismiss: CloseAndDismiss, dataKeyIds: IGetSiteEncryptionKeyDataKey[], coolDownPeriod: number) {
    return (
      <DialogWidget {...dialogProps}>
        <KMSKeyGenerateView closeDialog={closeAndDismiss} dataKeyIds={dataKeyIds} coolDownPeriod={coolDownPeriod} />
      </DialogWidget>
    );
  }